export default function (value, append = '€') {
  let s = (Number(value) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  if (append) s += append
  return s
}
